import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireAvia_dash } from "/home/runner/work/avia-js/avia-js/libs/plugins/dash/dist/avia.dash.cjs";
var avia_dashExports = requireAvia_dash();
export { avia_dashExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(avia_dashExports);